import styled from "@emotion/styled"

export const RemoveFiltersButton = styled.button`
  grid-column: 1 / 5;
  height: 50px;
  width: 275px;
  border: 3px solid #3d3d3d;
  border-radius: 7px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 30px;
  line-height: 50px;
  cursor: pointer;
`
